export default __webpack_public_path__ + "static/media/holiday-outline-16px.f89db888.svg";